import { registerFragment } from '@neptune/cx/registry';
import './styles.scss';


registerFragment('ay-heading', (fragmentElement, configuration, meta) => {

});

if (import.meta.hot) {
    import.meta.hot.accept();
}
